'use strict';
import isArray from 'lodash/isArray';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';
import {isRecoverable} from '../utils';


export const BASE_OPTIONS = {
  initialState: {},
  syncNotifierThrottle: 5000,
  syncModelAttemptThrottle: 1000,
  crossDomain: false,
  useDelete: false,
  parseItemResult,
  parseItem: defaultParseItem,
  parseItemSyncResult,

  isRecoverable,

  cacheOptions: null,
};

export const BASE_CACHE_OPTIONS = {
  throttle: 1000,
};

/**
 * @param {ReduxObservableItemOptions} options
 */
export function validateOptions(options) {
  if (!isFunction(options.syncNotifier))
    throw new Error('ReduxItemEpics missing required syncNotifier');

  if (!isFunction(options.itemPath))
    throw new Error('ReduxItemEpics missing required function itemPath');
  if (!isFunction(options.itemSyncPath))
    throw new Error('ReduxItemEpics missing required function itemSyncPath');

  if (!isFunction(options.parseItemResult))
    throw new Error('ReduxItemEpics missing required parseItemResult');

  if (!isFunction(options.parseItemSyncResult))
    throw new Error('ReduxItemEpics missing required parseItemSyncResult');

  if (options.useDelete) {
    if (!isFunction(options.deleteItemPath))
      throw new Error('ReduxItemEpics missing required deleteItemPath');
  }

  if (options.useSyncUpdates) {
    if (!isFunction(options.syncModelPath))
      throw new Error('ReduxItemEpics missing required syncModelPath');
    if (!isArray(options.syncModelActionsTypes))
      throw new Error('ReduxItemEpics missing required syncModelActionsTypes');
  }

  if (options.cacheOptions) {
    if (!isObject(options.cacheOptions.localForage))
      throw new Error('ReduxItemEpics missing required localForage instance');

    if (!isFunction(options.cacheOptions.getKey))
      throw new Error('ReduxItemEpics missing required cacheOptions.getKey');
  }
}

/**
 * @param {AjaxResponse} ajaxResponse
 * @param {ReduxObservableItemOptions~parseItem} [parseItem=defaultParseItem]
 * @return {T}
 */
export function parseItemResult(ajaxResponse, parseItem = defaultParseItem) {
  if (ajaxResponse && ajaxResponse.responseType === 'json') {
    if (isObject(ajaxResponse.response) && isObject(ajaxResponse.response.item)) {
      return {
        item: parseItem(ajaxResponse.response.item),
      };
    }
  }

  // Fallback
  return {
    item: null,
  };
}

/**
 * @param {T} item
 * @return {T}
 */
export function defaultParseItem(item) {
  return item;
}

/**
 * @param {AjaxResponse} ajaxResponse
 * @param {ReduxObservableItemOptions~parseSyncItem} [parseSyncItem=defaultParseItem]
 * @return {ItemSyncResult}
 */
export function parseItemSyncResult(ajaxResponse, parseSyncItem = defaultParseSyncItem) {
  if (ajaxResponse.status === 304) {
    return {
      hasChange: false,
    };
  } else if (ajaxResponse && ajaxResponse.responseType === 'json') {
    if (isObject(ajaxResponse.response) && isObject(ajaxResponse.response.item)) {
      return {
        hasChange: true,
        item: parseSyncItem(ajaxResponse.response.item),
      };
    }
  }

  // Fallback
  return {
    hasChange: true,
    item: null,
  };
}

function defaultParseSyncItem(item) {
  return item;
}

/**
 * Extract etag from state.
 * @param {ReduxObservableItemOptions} options
 * @param {ReduxObservableItemState} state
 * @returns {String}
 */
export function getEtag(options, state) {
  return state.item ? state.item.ETag : null;
}

/**
 * @param {ReduxObservableItemState} state
 * @return {T}
 */
export function getItemFromState(state) {
  return state.item;
}



// WEBPACK FOOTER //
// ./src/js/_libs/redux-observable-list/src/item/utils.js